import { Button, Grid } from '@material-ui/core';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useLinkStyles } from '../../../common/useLinkStyles';
import useAlertDialog from '../../../../redux/features/alertDialog/useAlertDialog';

const useStyles = makeStyles(() => ({
  sectionInfo: {
    margin: '1rem 0',
  },
  sectionInfoDisplay: {
    display: 'flex',
  },
  link: {
    background: 'none',
    padding: 0,
    '&:hover': {
      background: 'none',
      padding: 0,
    },
  },
}));

/**
 * Compliance link with info dialog that can appear on top of an attachment field.
 * @returns {JSX.Element}
 * @constructor
 */
export default function AttachmentComplianceInfo() {
  const { t } = useTranslation();

  const classes = useStyles();
  const linkClass = useLinkStyles();
  const { openAlertDialog } = useAlertDialog();

  const handleComplianceButton = async () => {
    openAlertDialog({
      updatedTexts: {
        title: 'attachments.pdf.compliance.checklist.title',
        message: 'attachments.pdf.compliance.checklist.text',
        confirmButton: 'actions.ok',
        cancelButton: 'actions.cancel',
      },
      updatedSettings: {
        showCloseButton: true,
      },
    });
  };

  return (
    <Grid container direction="row" alignItems="center" className={classes.sectionInfo}>
      <div className={classes.sectionInfoDisplay}>
        <>
          <Button
            id="pdfComplianceAlert"
            className={`${classes.link} ${linkClass.link}`}
            onClick={() => handleComplianceButton()}
          >
            {t('attachments.pdf.compliance.checklist.link')}
            <PlaylistAddCheckIcon />
          </Button>
        </>
      </div>
    </Grid>
  );
}
